import React from 'react';
import { LocationCards } from '../../../components/LocationCards';
import { useRefreshLocationList, useSingleLocationRedirect } from '../../../hooks/data-hooks';
import { ContentContainer } from '../../../components/ContentContainer';
import { LocationsDropdownToolbar } from '../../../components/LocationsDropdownToolbar/LocationsDropdownToolbar';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { isDataError, isDataLoaded } from '../../../types';
import { LocationListProvider } from '../../../data/DataProviders/LocationListProvider';
import { DataIndicators } from '../../../components/DataIndicators';


export const OverviewOrganization: React.FC = () => {
    const { t } = useLanguageLocale();
    const locationListData = useRefreshLocationList();

    const isEmpty = isDataLoaded(locationListData) && locationListData.value.locations.length === 0;
    const isErrorInfo = isEmpty || isDataError(locationListData);
    useSingleLocationRedirect();

    return (
        <>

            <LocationsDropdownToolbar title={t('DASHBOARD.OVERVIEW_TITLE')} />

            <ContentContainer justifyContent="start" testId="organization-overview-page">
                <DataIndicators
                    errorMessage={t('DASHBOARD.ORGANIZATION')}
                    emptyMessage={t('DASHBOARD.LOCATION')}
                    data={locationListData}
                    emptyIcon="LocationCity"
                    isEmpty={isEmpty}
                    isDetailedInfo={isErrorInfo}
                />
                {(isDataLoaded(locationListData) && locationListData.value.locations.length > 1 &&

                    <LocationListProvider locationList={locationListData.value.locations}
                        organizationId={locationListData.value.organizationId}>
                        <LocationCards />
                    </LocationListProvider>
                )}
            </ContentContainer>
        </>
    );
};